import { nextArrow, prevArrow, options } from "@/global/slick-options";
import { get, getAll } from "@/utilities/querySelector";


const galleries = getAll( 'section.gallery' );

galleries.forEach( gallery => {
  const noNav = get( '.no-nav', gallery );
  const withNav = get( '.with-nav', gallery );
  const nav = get( '.nav', gallery );

  if ( noNav ) {
    jQuery( noNav ).slickLightbox( {
      src: 'href',
      itemSelector: '.image-slide a',
      prevArrow,
      nextArrow,
    } );
  }

  if ( withNav && nav ) {

    jQuery( withNav ).slick( {
      ...options,
      infinite: true,
      slidesToShow: 1,
      arrows: false,
      asNavFor: nav
    } );

    jQuery( nav ).slick( {
      ...options,
      infinite: true,
      centerMode: true,
      centerPadding: '0',
      focusOnSelect: true,
      asNavFor: withNav,
      slidesToShow: 7,
      respondTo: 'slider',
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 5,
            centerMode: true,

          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 3,
            centerMode: true,

          }
        },
      ]
    } );

    jQuery( '.gallery-slider.with-nav' ).slickLightbox( {
      src: 'href',
      itemSelector: '.image-slide a',
      prevArrow,
      nextArrow,
    } );
  }
} );

jQuery('.collage-grid .card--project').slickLightbox({
  src: 'href',
  itemSelector: '.card-links a',
  caption: 'caption',
  prevArrow: '<svg class="slick-arrow slick-prev" width="15" height="24" viewBox="0 0 15 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><g id="Path.-Copy.-4" transform="matrix(1,0,0,1,-20,-328)"><path d="M34.742,330.061L24.802,340L34.742,349.939L32.62,352.061L20.56,340L32.62,327.939L34.742,330.061Z"/></g></svg>',
  nextArrow: '<svg class="slick-arrow slick-next" width="15" height="24" viewBox="0 0 15 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><g id="Path.-Copy.-3" transform="matrix(-1,7.65714e-16,-7.65714e-16,-1,373.362,352)"><path d="M358.56,340L370.62,327.939L372.742,330.061L362.802,340L372.742,349.939L370.62,352.061L358.56,340Z"/></g></svg>',
});
